import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import ImageUpload from './ImageUpload';

interface SkuImagesEditorProps {
  // 该规格图集：多个 URL 换行分隔（与后端 ProductSku.images 一致）；第一张为封面
  value?: string;
  onChange?: (v: string) => void;
  specName?: string;
}

/**
 * 规格图集管理（弹窗式）
 * - 表格里只占一个「图集 (N)」按钮，点开 Modal 管理该规格的一组图，避免撑高/挤乱规格行
 * - 0/1/N 张都合法：不配则详情页沿用商品公共图集；配一张即换封面；配一组即整组切换（京东式）
 */
const SkuImagesEditor: React.FC<SkuImagesEditorProps> = ({ value, onChange, specName }) => {
  const [open, setOpen] = useState(false);
  const urls = value ? String(value).split('\n').map((s) => s.trim()).filter(Boolean) : [];

  return (
    <>
      <Button size="small" icon={<PictureOutlined />} onClick={() => setOpen(true)} block>
        图集 ({urls.length})
      </Button>
      <Modal
        title={`规格图集${specName ? ` · ${specName}` : ''}`}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
        okText="完成"
        cancelText="关闭"
        width={640}
      >
        <div style={{ color: '#6b7280', fontSize: 13, lineHeight: 1.7, marginBottom: 12 }}>
          该规格专属的一组图，<b>第一张为封面</b>。用户在详情页选中此规格时，顶部轮播整组切换；
          不配则沿用商品公共图集。规格间外观差异不大可只放一张或留空。
        </div>
        <ImageUpload
          multiple
          value={urls}
          onChange={(v) => onChange?.((Array.isArray(v) ? v : []).join('\n'))}
          tip="建议 1:1（如 800×800），可上传多张"
        />
      </Modal>
    </>
  );
};

export default SkuImagesEditor;
